<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{task}} Metals {{task === 'Edit' ? ' (ID: ' + metalsForm.get('id')?.value + ')' : ''}}
  </div>
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="metalsForm" (ngSubmit)="saveMetals()" class="form-grid">
    <div class="form-grid-row">
      <!-- Row 1: Lab & Testing Type -->
      <mat-form-field appearance="outline">
        <mat-label>Lab</mat-label>
        <mat-select formControlName="m_LabId">
          <mat-option [value]="null">- Select Lab -</mat-option>
          @for (lab of labTypes(); track lab.id) {
          <mat-option [value]="lab.id">{{ lab.name }}</mat-option>
          }
        </mat-select>
        @if (metalsForm.get('m_LabId')?.hasError('required') && attemptSave()) {
        <mat-error>Lab is required</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Testing Type </mat-label>
        <mat-select formControlName="testingType">
          <mat-option [value]="null">- Select Testing Type -</mat-option>
          <mat-option *ngFor="let testingType of testingTypes()" [value]="testingType.id">
            {{ testingType.name }}
          </mat-option>
        </mat-select>
        @if (metalsForm.get('testingType')?.hasError('required') && attemptSave()) {
        <mat-error>Testing Type is required</mat-error>
        }
      </mat-form-field>

      <!-- Row 2: Sample Id & Labreport Id -->
      <mat-form-field appearance="outline">
        <mat-label>Sample Id</mat-label>
        <input matInput formControlName="m_SampleID" placeholder="Enter SampleId" maxlength="15">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Lab Report Id</mat-label>
        <input matInput formControlName="m_LabreportID" placeholder="Enter Lab ReportId" maxlength="15">
        @if (metalsForm.get('m_LabreportID')?.hasError('required') && attemptSave()) {
        <mat-error>Lab ReportId is required</mat-error>
        }
      </mat-form-field>

    </div>
    <div class="form-grid-row">

      <!-- Row 3: Sample Date & Test Date -->
      <mat-form-field appearance="outline">
        <mat-label>Sample Date</mat-label>
        <input matInput [matDatepicker]="samplePicker" formControlName="m_DateSampled">
        <mat-datepicker-toggle matSuffix [for]="samplePicker"></mat-datepicker-toggle>
        <mat-datepicker #samplePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Test Date</mat-label>
        <input matInput [matDatepicker]="testPicker" formControlName="m_DateTested">
        <mat-datepicker-toggle matSuffix [for]="testPicker"></mat-datepicker-toggle>
        <mat-datepicker #testPicker></mat-datepicker>
      </mat-form-field>

      <!-- Row 4: Input Type & TS (mg/l) -->
      <mat-form-field appearance="outline">
        <mat-label>Input Type</mat-label>
        <mat-select formControlName="metalInput">
          <mat-option [value]="null">- Select Input Type -</mat-option>
          <mat-option *ngFor="let inputType of inputTypes()" [value]="inputType.name">
            {{ inputType.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>TS (mg/l)</mat-label>
        <input matInput type="text" formControlName="ts_mg_L" placeholder="Enter TS"
          (input)="roundOff($event, 999999, 4, 0, 'ts_mg_L')" />
      </mat-form-field>

      <!-- as & cd -->
      <mat-form-field appearance="outline">
        <mat-label>AS (Arsenic)</mat-label>
        <input matInput formControlName="as_Dry" placeholder="Enter AS" maxlength="10">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>CD (Cadmium)</mat-label>
        <input matInput formControlName="cd_Dry" placeholder="Enter CD" maxlength="10">
      </mat-form-field>
    </div>
    <div class="form-grid-row">

      <!-- cr & co -->
      <mat-form-field appearance="outline">
        <mat-label>CR (Chromium)</mat-label>
        <input matInput formControlName="cr_Dry" placeholder="Enter CR" maxlength="10">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>CO (Cobalt)</mat-label>
        <input matInput formControlName="co_Dry" placeholder="Enter CO" maxlength="10">
      </mat-form-field>

      <!-- cu & pb -->
      <mat-form-field appearance="outline">
        <mat-label>CU (Copper)</mat-label>
        <input matInput formControlName="cu_Dry" placeholder="Enter CU" maxlength="10">
      </mat-form-field>
    </div>

    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>PB (Lead)</mat-label>
        <input matInput formControlName="pb_Dry" placeholder="Enter PB" maxlength="10">
      </mat-form-field>

      <!-- hg & mo -->
      <mat-form-field appearance="outline">
        <mat-label>HG (Mercury)</mat-label>
        <input matInput formControlName="hg_Dry" placeholder="Enter HG" maxlength="10">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>MO (Molybdenum)</mat-label>
        <input matInput formControlName="mo_Dry" placeholder="Enter MO" maxlength="10">
      </mat-form-field>

    </div>
    <div class="form-grid-row">

      <!-- ni & se -->
      <mat-form-field appearance="outline">
        <mat-label>NI (Nickel)</mat-label>
        <input matInput formControlName="ni_Dry" placeholder="Enter NI" maxlength="10">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>SE (Selenium)</mat-label>
        <input matInput formControlName="se_Dry" placeholder="Enter SE" maxlength="10">
      </mat-form-field>

      <!-- zn & notes -->
      <mat-form-field appearance="outline" style="height: 55px !important">
        <mat-label>ZN (Zinc)</mat-label>
        <input matInput formControlName="zn_Dry" placeholder="Enter ZN" maxlength="10">
      </mat-form-field>
    </div>
    
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="notes" placeholder="Enter Notes" rows="3" maxlength="30000"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" (click)="close()"> Cancel</button>
  @if(canSave){
    <button mat-raised-button color="primary" (click)="saveMetals()">Save</button>
  }
</mat-dialog-actions>